// Core Modules
import React from 'react';
import {Link} from 'react-router-dom';
// Dependancy Modules
import * as firebase from 'firebase/app';
import 'firebase/auth';

const Logout = () => {
    firebase.auth().signOut()
    .then(() => {
       sessionStorage.setItem('auth_data', '');
       window.location.pathname = '/';
    });
}

const Navbar = () => {

    let HeaderString = '';
    if (window.location.pathname === '/') {
        HeaderString = 'Home';
    }else if (window.location.pathname.includes('exams')) {
        HeaderString = 'Exams';
    }else if (window.location.pathname.includes('results')) {
        HeaderString = 'Exam Results';
    }

    return ( 
        <nav className="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top ">
            <div className="container-fluid">
                <div className="navbar-wrapper">
                    <span className="navbar-brand">{HeaderString}</span>
                </div>
                <button className="navbar-toggler" type="button" data-toggle="collapse" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="sr-only">Toggle navigation</span>
                    <span className="navbar-toggler-icon icon-bar"></span>
                    <span className="navbar-toggler-icon icon-bar"></span>
                    <span className="navbar-toggler-icon icon-bar"></span>
                </button>
                <div className="collapse navbar-collapse justify-content-end">
                    <form className="navbar-form">
                        <div className="input-group no-border">
                        </div>
                    </form>
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link className="nav-link" to="/">
                                <i className="material-icons">dashboard</i>
                                <p className="d-lg-none d-md-block">
                                    Home
                                </p>
                            </Link>
                        </li>
                        <li className="nav-item dropdown">
                            <div className="nav-link" id="navbarDropdownProfile" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="material-icons">person</i>
                                <p className="d-lg-none d-md-block">
                                    Account
                                </p>
                            </div>
                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownProfile">
                                <Link className="dropdown-item" to="/">Profile</Link>
                                <div className="dropdown-divider"></div>
                                <span className="dropdown-item" onClick={Logout}>Log out</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}
 
export default Navbar;